import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../config/axiosConfig'; 
import config from "../../config/api";
const API_URL = config.backendUrl

export const submitWorkEntries = createAsyncThunk(
  'submitWorkEntries/submit',
  async ({ projectid, taskownerid }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/submit-task`, {
        projectid,
        taskownerid,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);


const submitWorkentriesSlice = createSlice({
  name: 'submitWorkEntries',
  initialState: {
    loading: false,
    successMessage: null,
    error: null,
  },
  reducers: {
    clearSubmitStatus: (state) => {
      state.loading = false;
      state.successMessage = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitWorkEntries.pending, (state) => {
        state.loading = true;
        state.successMessage = null;
        state.error = null;
      })
      .addCase(submitWorkEntries.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message;
        state.error = null;
      })
      .addCase(submitWorkEntries.rejected, (state, action) => {
        state.loading = false;
        state.successMessage = null;
        state.error = action.payload;
      });
  },
});

export const { clearSubmitStatus } = submitWorkentriesSlice.actions;

export default submitWorkentriesSlice.reducer;
